import React, { useState, useEffect, useRef } from "react";
import InvestHeroSection from "./InvestHeroSection";
import WhyInvestSection from "./WhyInvestSection";
import InvestmentOpportunitiesSection from "./InvestmentOpportunitiesSection";
import InvestorBenefitsSection from "./InvestorBenefitsSection";
import FundUtilizationSection from "./FundUtilizationSection";
import InvestorFormSection from "./InvestorFormSection";
import FutureTogetherSection from "./FutureTogetherSection";

const Investors = () => {
  return (
    <div className="min-h-screen bg-white">
      <InvestHeroSection />
      <WhyInvestSection />
      <InvestmentOpportunitiesSection />
      <InvestorBenefitsSection />
      <FundUtilizationSection />
      <InvestorFormSection />
      <FutureTogetherSection />
    </div>
  );
};

export default Investors;
